export default {
  tips: '建议使用谷歌Chrome浏览器以获得最好的体验',
  account: '帐号名',
  pwd: '密码',
  confirmPwd: '确认密码',
  areaCode: '国家',
  email: '邮箱',
  phone: '手机号',
  code: '验证码',
  sellerType: '卖家类型',
  company: '企业',
  personal: '个人',
  telephone: '座机',
  fax: '传真',
  reluMsgAccount: '支持英文字母、数字、下划线，长度至少4位',
  reluMsgRegistered: '对不起，该账号已被注册',
  reluMsgPwd: '密码至少6位',
  reluMsgConfirmPwd: '请确保密码一致',
  reluMsgareaCode: '请选择国家',
  reluMsgEmail: '请输入正确的邮箱',
  reluMsgPhone: '请输入正确的手机号码',
  reluMsgCode: '请输入验证码',
  reluMsgCheckCode: '验证码错误',
  checkFaild: '验证码校验失败',
  reluMsgCheckSN: '请先点击发送验证码',
  reluMsgMerchantType: '请选择商户类型',
  reluMsgTelephone: '',
  reluMsgFax: '',
  successText: '验证通过!',
  failText: '验证失败，请重试',
  sliderText: '拖动滑块完成拼图',
  businessIfYou: '我是企业实体（含个体工商户）',
  individualIfYou: '我是个人（仅支持非洲卖家）',
  fillInPhoneNumber: '输入手机号码',
  useToReceiveAccountRelated: '用来接收帐号相关的通知',
  referralCode: '推荐码',
  oauthLoginTitle: '当前登录账号：{account}（消费者账号）',
  oauthLoginDesc: '本次开通的商户将直接绑定至该账号。',
  oauthBindTitle: '温馨提示：提交申请后，商户角色将与消费者账号 {account} 绑定，',
  oauthBindDesc: '一个全局账号即可同时管理消费者与经营权限。',
  existingAccountTitle: '该账户已存在商户账号：{account}',
  existingAccountQuestion: '是否直接登录？',
  existingAccountCancel: '取消',
  existingAccountConfirm: '确定',
  existingAccountConfirmTip: '登录操作待定。'
}
